import React from "react";
import { useParams, useNavigate } from "react-router-dom";

const PovVideo = ({ videoData }) => {
  const { id } = useParams();
  let navigate = useNavigate();

  const goBack = () => {
    navigate("/");
  }

  return (
    <div onClick={goBack}>
        <video
            className="isuzu-video vw-100 vh-100 fixed-top"
            src={`/assets/videos/${videoData[parseInt(id) - 1].video}.mp4`}
            autoPlay
            onEnded={goBack}
        >
        </video>
    </div>
        
  );
};

export default PovVideo;
